import React from 'react';
import { FeatureCardProps } from '../types';
import { CardLayout } from './CardLayout';
import { CardContent } from './CardContent';
import { CardHeader } from './CardHeader';

interface CardFrontProps extends FeatureCardProps {
  isFlipped: boolean;
}

export default function CardFront({ 
  icon: Icon, 
  benefitHeadline, 
  benefitBody, 
  isFlipped 
}: CardFrontProps) {
  return (
    <CardLayout isFlipped={isFlipped}>
      <CardContent>
        <CardHeader Icon={Icon} title={benefitHeadline} iconPosition="left" />
        
        <p className="text-gray-600 flex-grow mb-4">{benefitBody}</p>
        
        <div className="text-[#f9c55f] text-sm flex items-center justify-end mt-auto">
          <span className="font-bold">Click to discover the feature behind</span>
          <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
      </CardContent>
    </CardLayout>
  );
}